import { DateTime } from 'luxon';

const isNil = value => value === null || value === undefined;

export const useCalculateSmartBeatValues = ({
  task,
  hoursWorked,
  calculatedHoursRemaining,
  actualHoursToDate,
  calculatedEstimatedCompletionDate,
  initialEstimate
}) => {
  const previousWork = actualHoursToDate ? actualHoursToDate - hoursWorked : 0;

  if (!task) {
    return {
      dateDelta: null,
      estimatedCompletionDate: null,
      estimatedHoursAtCompletion: null,
      estimatedHoursAtCompletionDelta: null,
      previousWork,
      workRemaining: null
    };
  }

  const estimatedHoursAtCompletion = isNil(calculatedHoursRemaining)
    ? actualHoursToDate
    : calculatedHoursRemaining + actualHoursToDate;
  const estimatedHoursAtCompletionDelta = isNil(initialEstimate)
    ? null
    : estimatedHoursAtCompletion - initialEstimate;
  const estimatedCompletionDate =
    calculatedEstimatedCompletionDate || task.endDate || null;
  const dateDelta = task.endDate
    ? DateTime.fromISO(estimatedCompletionDate).diff(
        DateTime.fromISO(task.endDate),
        'days'
      ).values.days
    : null;

  return {
    dateDelta,
    estimatedCompletionDate,
    estimatedHoursAtCompletion,
    estimatedHoursAtCompletionDelta,
    previousWork,
    workRemaining: calculatedHoursRemaining
  };
};

export default useCalculateSmartBeatValues;
